// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, Image, Typography } from "@outschool/backpack";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useImpressionTracking } from "@outschool/ui-legacy-component-library";
import { UserAgent, useIsSmall, useNodeRef } from "@outschool/ui-utils";
import React from "react";

import { useCurrentLearner } from "../../providers/CurrentLearnerProvider";
import { DESKTOP_BANNER_HEIGHT, MOBILE_BANNER_HEIGHT } from "./consts";
import phoneWithDogSmall from "./images/phone-with-dog-small.png";
import phoneWithDog from "./images/phone-with-dog.png";

const IosAppPromoBanner = () => {
  const trackingPrefix = "banner.ios";
  const [impressionNode, setImpressionNode] = useNodeRef();
  useImpressionTracking({
    node: impressionNode,
    uniqueId: trackingPrefix,
    trackingLabel: trackingPrefix,
    trackViews: true,
  });

  const currentLearner = useCurrentLearner();
  const showIosAppDownloadLink = Boolean(currentLearner?.age ?? 0 >= 13);
  const isSmall = useIsSmall();
  return (
    <Box
      sx={(theme: $TSFixMe) => ({
        backgroundImage: `linear-gradient(360deg, #FFD544 0%, #FFF3D3 100%), linear-gradient(162.93deg, #FDFCFD 0%, #F0F6F8 104.03%)`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        // offset 60px top nav height for mobile
        height: `calc(${MOBILE_BANNER_HEIGHT}px - 60px)`,
        marginTop: "60px",
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        [theme.breakpoints.up("sm")]: {
          height: DESKTOP_BANNER_HEIGHT,
          marginTop: 0,
        },
      })}
      data-test-id="ios-promo-banner"
      ref={setImpressionNode}
    >
      <Box
        sx={(theme: $TSFixMe) => ({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          left: 100,

          [theme.breakpoints.up("sm")]: {
            left: 200,
          },
        })}
      >
        <Typography variant="h6">
          Get the {UserAgent.isIPhone() ? "iPhone" : "iPad"} app!
        </Typography>
        {showIosAppDownloadLink ? (
          <TrackedButton
            variant="contained"
            component="a"
            href="https://apps.apple.com/us/app/outschool/id1594191740"
            sx={{
              borderRadius: "1em",
              marginTop: "0.5em",
              zIndex: 1,
            }}
            trackingName={trackingPrefix}
          >
            Download Now
          </TrackedButton>
        ) : (
          <Typography
            variant="inherit"
            sx={{
              whiteSpace: "nowrap",
            }}
          >
            Ask your family to download
          </Typography>
        )}
      </Box>
      <Image
        src={isSmall ? phoneWithDogSmall : phoneWithDog}
        sx={{
          height: "100%",
        }}
      />
    </Box>
  );
};

export default IosAppPromoBanner;
